import { AuthGuard, CrudOp, geometryAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { useRequiredProjectParam } from "@org-avp/avp-avengers-ui-shared-store";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const KVSSearchView: FC = () => {
  const brand = useRequiredProjectParam("brand");
  return (
    <AuthGuard authScope={geometryAuthScope} brand={brand} crudOp={CrudOp.READ}>
      <Suspense><LazyKVSSearchView/></Suspense>
    </AuthGuard>
  );
};

const LazyKVSSearchView = lazy(importView(
  () => import("../components/KVSSearchView"),
  (it) => it.KVSSearchView,
));
